import { useLayoutEffect, useRef } from 'react';
import { throttle } from '@common/utils/functions';
function useResizeObserver(callback, timeOut) {
    const ref = useRef(null);
    useLayoutEffect(() => {
        const element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) {
            return;
        }
        const observer = new ResizeObserver(throttle((entries) => {
            callback(element, entries[0]);
        }, timeOut || 1000));
        observer.observe(element);
        return () => {
            observer.disconnect();
        };
    }, [callback, ref]);
    return ref;
}
export default useResizeObserver;
